import { apiClient } from "./apiClient";

/**
 * Metric catalog + runner and scheduled-report CRUD are real (admin routes
 * added for a safe, allowlisted query layer -- the catalog is a fixed set of
 * metric_keys server-side, never raw SQL from the browser). Scheduled
 * reports are owner-scoped: listScheduledReports only ever returns the
 * caller's own saved reports.
 *
 * GAP that remains: schedule_cron is stored but nothing executes it --
 * there's no Timer-triggered function/cron runner wired up yet, so saved
 * reports don't actually get run or emailed on a schedule. See the note in
 * CustomReportingPage.jsx.
 *
 * dataIntegrityChecks is a separate, still-fully-gapped feature (no backend
 * route exists for it at all).
 */
export const customReportsApi = {
  listMetrics: () => apiClient.get("/management/reports/metrics").then((r) => r.data),
  runMetric: (metricKey) => apiClient.get(`/management/reports/metrics/${metricKey}`).then((r) => r.data),

  listScheduledReports: () => apiClient.get("/management/reports/scheduled").then((r) => r.data),
  createScheduledReport: (payload) => apiClient.post("/management/reports/scheduled", payload).then((r) => r.data),
  deleteScheduledReport: (reportId) => apiClient.delete(`/management/reports/scheduled/${reportId}`).then((r) => r.data),

  dataIntegrityChecks: () => apiClient.get("/management/reports/data-integrity").then((r) => r.data),

  templates: () => [
    { id: "weekly-growth", name: "Weekly Growth Summary", metrics: ["new_users", "active_hives", "mrr"] },
    { id: "monthly-health", name: "Monthly Platform Health", metrics: ["error_rate", "avg_response_time", "storage_growth"] },
    { id: "support-sla", name: "Support SLA Compliance", metrics: ["avg_response_time", "avg_resolution_time", "sla_pct"] },
  ],
};
